
var vskoContent = angular.module('vskoContent', []);
vskoContent.directive('vskoContent', [function() {

  return {
    restrict: 'E',
    template: require('./vsko-content.html'),
    transclude: true,
   
    scope: {
      limitWidth: '=',
      center: '='
    },
    link: function ($scope, element, attrs, ctrl) {
      'use strict';
      var table = element.find('table');
      if (table) {
        table.addClass('table');
      }
    }
  }
}]);
